import React, { Component } from "react";
import { ImArrowLeft } from 'react-icons/im';
import '../Styles/ProjectHeader.css';

export default class ProjectHeader extends Component {
  
  render() {

    const { history, skills } = this.props;

    window.onscroll = function() {
      var scroll = window.pageYOffset;
      var header = document.querySelector("header");
    
      if (scroll >= 50) {
        header.classList.add("scrolled");
      } else {
        header.classList.remove("scrolled");
      }
    };

    return (
      <header 
        className="header-details"
        data-aos="fade-down" 
        data-aos-duration="800"
      >
          <ImArrowLeft 
            className="back-button" 
            onClick={ () =>  history.goBack() }
          />
          <div className="project-details-skills">
            {
              skills && skills.map((icon, index) => <div key={ index }>{ icon }</div>)
            }
          </div>
          
        </header>
    )
  }
}